import React from 'react';

interface SummaryItemProps {
  title: string;
  value: number | string;
  unit: string;
  isSelected?: boolean;
  onClick?: () => void;
}

const SummaryItem: React.FC<SummaryItemProps> = ({
  title,
  value,
  unit,
  isSelected = false,
  onClick,
}) => {
  const formattedValue = typeof value === 'number' ? value.toLocaleString() : value;

  return (
    <li className='w-[calc(25%-(3/4*8px))]'>
      <a
        className={`flex w-full flex-1 cursor-pointer flex-col gap-1 border-b-2 px-[calc((12/144)*100%)] pb-1 pt-2 
          ${
            isSelected
              ? 'border-b-primary-500 bg-primary-50 text-primary-500'
              : 'border-transparent text-[#666666]'
          }`}
        onClick={onClick}
      >
        <h3 className='text-xs font-medium leading-none'>{title}</h3>
        <div className={`break-words text-lg font-medium ${!isSelected ? 'text-black' : ''}`}>
          {formattedValue}
          <span className='text-xs font-medium'>{unit}</span>
        </div>
      </a>
    </li>
  );
};

export default SummaryItem;
